module.exports = __webpack_public_path__ + "img/cand-approval-reject.d0d73201.svg";